import classNames from 'classnames';
import React, { useCallback, useContext } from 'react';
import { NavLink } from 'react-router-dom';

import { SizeContext } from 'components/context/SizeProvider';
import { useLayoutStore } from 'stores/useLayoutStore';

export const SidebarLink = ({ to, href, children, isCollapsed, label }) => {
  const { setSidebarCollapse } = useLayoutStore();
  const { isMobile } = useContext(SizeContext);

  const handleClick = useCallback(() => {
    if(isMobile) setSidebarCollapse(true);
  }, [setSidebarCollapse, isMobile]);

  const cssClasses = classNames(
    // 15px below md: the links are the main content of a full-screen sheet there, not a
    // narrow docked rail, and 14px read as undersized against the phone's other text.
    'group flex w-full items-center font-normal py-3 text-[15px] md:text-sm space-x-2.5 whitespace-nowrap rounded-field',
    'transition-all duration-200 ease-out',
    'hover:text-ui hover:bg-ui-overlay',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-ui-accent-ring',
    {
      'justify-center px-3': isCollapsed,
      'px-4': !isCollapsed
    }
  );

  const iconClasses = 'transition-transform duration-200 ease-out group-hover:scale-110 group-focus:scale-110 shrink-0';

  const enhancedChildren = React.Children.map(children, child => {
    if(React.isValidElement(child) && child.type !== 'span') {
      return React.cloneElement(child, {
        className: classNames(child.props.className, iconClasses)
      });
    }
    if(React.isValidElement(child) && child.type === 'span') {
      return React.cloneElement(child, {
        className: classNames(child.props.className, 'transition-all duration-200 ease-out group-hover:translate-x-1')
      });
    }
    return child;
  });

  if(href) return (
    <a className={cssClasses} href={href} target="_blank" rel="noreferrer">
      {enhancedChildren}
    </a>
  )
  return (
    <NavLink
      aria-label={label}
      className={({ isActive }) => classNames(cssClasses, {
        'text-ui-accent bg-ui-overlay': isActive,
        'text-ui-3': !isActive
      })}
      to={to}
      onClick={handleClick}
    >{enhancedChildren}
    </NavLink>
  );
}
